import axios from '../api' // 倒入 api


//获取传感器列表
const getTemperSensorMessage = (data) => {
    return axios({
      url: '/api/temperature/sensor/list',
      method: 'POST',
      data
    })
  }

//获取传感器信息
const getTemperSensorDetail = (sensorId) => {
    return axios({
      url: `/api/temperature/sensor/${sensorId}`,
      method: 'GET',
    })
  }

//删除传感器
const delTemperSensor = (sensorId) => {
    return axios({
      url: `/api/temperature/sensor/${sensorId}`,
      method: 'DELETE',
    })
  }

//新增传感器
const addTemperSensor = (data) => {
    return axios({
      url: `/api/temperature/sensor`,
      method: 'POST',
      data
    })
  }

//修改传感器
const modifyTemperSensor = (data) => {
    return axios({
      url: `/api/temperature/sensor`,
      method: 'PUT',
      data
    })
  }

//获取温度设置列表
const getTemperSetting = (data) => {
  return axios({
    url: '/api/temperature/manage/list',
    method: 'POST',
    data
  })
}

//获取参数参考对象
const getTemperRefer = () => {
  return axios({
    url: `/api/temperature/manage/refer`,
    method: 'GET',
  })
}

//设置温度
const setTemp = (data) => {
  return axios({
    url:`/api/temperature/manage`,
    method: 'POST',
    data
  })
}

//接触温度传感器绑定
const delTempBind = (carTemperatureSensorId) => {
  return axios({
    url: `/api/temperature/manage/${carTemperatureSensorId}`,
    method: 'DELETE',
  })
}

//下发参数
const getTempCommand = (carTemperatureSensorId) => {
  return axios({
    url: `/api/temperature/manage/command/${carTemperatureSensorId}`,
    method: 'GET'
  })
}

//获取温度设置详情
const getTempSetDetail = (carId) => {
  return axios({
    url: `/api/temperature/manage/${carId}`,
    method: 'GET',
  })
}

//新增湿度传感器
const addHumSensor = (data) => {
  return axios({
    url: `/api/humidity/sensor`,
    method: 'POST',
    data
  })
}

//修改湿度传感器
const modifyHumSensor = (data) => {
  return axios({
    url: `/api/humidity/sensor`,
    method: 'PUT',
    data
  })
}


//获取湿度传感器列表
const getHumSensorMessage = (data) => {
  return axios({
    url: '/api/humidity/sensor/list',
    method: 'POST',
    data
  })
}

//获取传感器信息
const getHumSensorDetail = (sensorId) => {
  return axios({
    url: `/api/humidity/sensor/${sensorId}`,
    method: 'GET',
  })
}

//删除传感器
const delHumSensor = (sensorId) => {
  return axios({
    url: `/api/humidity/sensor/${sensorId}`,
    method: 'DELETE',
  })
}

//获取湿度传感器参考对象
const getHumRefer = () => {
  return axios({
    url: `/api/humidity/manage/refer`,
    method: 'GET',
  })
}

//下发湿度传感器参数
const getHumCommand = (carHumiditySensorId) => {
  return axios({
    url: `/api/humidity/manage/command/${carHumiditySensorId}`,
    method: 'GET'
  })
}

//接触湿度传感器绑定
const delHumBind = (carHumiditySensorId) => {
  return axios({
    url: `/api/humidity/manage/${carHumiditySensorId}`,
    method: 'DELETE',
  })
}

//获取湿度设置列表
const getHumSetting = (data) => {
  return axios({
    url: '/api/humidity/manage/list',
    method: 'POST',
    data
  })
}

//获取湿度设置详情
const getHumSetDetail = (carId) => {
  return axios({
    url: `/api/humidity/manage/${carId}`,
    method: 'GET',
  })
}

//设置湿度
const setHum = (data) => {
  return axios({
    url:`/api/humidity/manage`,
    method: 'POST',
    data
  })
}

//获取载重传感器列表
const getLoadSensorMessage = (data) => {
  return axios({
    url: '/api/load/sensor/list',
    method: 'POST',
    data
  })
}

//获取载重传感器信息
const getLoadSensorDetail = (sensorId) => {
  return axios({
    url: `/api/load/sensor/${sensorId}`,
    method: 'GET',
  })
}

//删除载重传感器
const delLoadSensor = (sensorId) => {
  return axios({
    url: `/api/load/sensor/${sensorId}`,
    method: 'DELETE',
  })
}

//新增载重传感器
const addLoadSensor = (data) => {
  return axios({
    url: `/api/load/sensor`,
    method: 'POST',
    data
  })
}

//修改载重传感器
const modifyLoadSensor = (data) => {
  return axios({
    url: `/api/load/sensor`,
    method: 'PUT',
    data
  })
}

//获取载重参数参考对象
const getLoadRefer = () => {
  return axios({
    url: `/api/load/manage/refer`,
    method: 'GET',
  })
}

//获取载重设置列表
const getLoadSetting = (data) => {
  return axios({
    url: '/api/load/manage/list',
    method: 'POST',
    data
  })
}

//获取载重设置详情
const getLoadSetDetail = (carId) => {
  return axios({
    url: `/api/load/manage/${carId}`,
    method: 'GET',
  })
}

//下发载重传感器参数
const getLoadCommand = (carLoadSensorId) => {
  return axios({
    url: `/api/load/manage/command/${carLoadSensorId}`,
    method: 'GET'
  })
}

//解除载重传感器绑定
const delLoadBind = (carLoadSensorId) => {
  return axios({
    url: `/api/load/manage/${carLoadSensorId}`,
    method: 'DELETE',
  })
}

//设置载重
const setLoad = (data) => {
  return axios({
    url:`/api/load/manage`,
    method: 'POST',
    data
  })
}

//获取胎压列表
const getPressureSensorList = (data) => {
  return axios({
    url: `/api/pressure/sensor/list`,
    method: 'POST',
    data
  })
}

//获取胎压列表(不分页)
const getPressureSensorSimpleList = () => {
  return axios({
    url: `/api/pressure/sensor/list`,
    mthod: 'GET',
  })
}

//新建胎压传感器
const addPresureSensor = (data) => {
  return axios({
    url: `/api/pressure/sensor`,
    method: 'POST',
    data
  })
}

//修改胎压传感器
const modifyPresureSensor = (data) => {
  return axios({
    url: `/api/pressure/sensor`,
    method: 'PUT',
    data
  })
}
//删除胎压传感器
const delPresureSensor = (sensorId) => {
  return axios({
    url: `/api/pressure/sensor/${sensorId}`,
    method: 'DELETE',
  })
}

//获取胎压管理列表
const getPresureManage = (data) => {
  return axios({
    url: `/api/pressure/manage/list`,
    method: 'POST',
    data
  })
}

//胎压管理参考对象
const getPresureRefer = () => {
  return axios({
    url: `/api/pressure/manage/refer`,
    method: 'GET',
  })
}

//车辆设置传感器
const setPresureManage = (data) => {
  return axios({
    url: `/api/pressure/manage`,
    method: 'POST',
    data
  })
}

//胎压管理设置详情
const getPresureDetail = (carId) => {
  return axios({
    url: `/api/pressure/manage/${carId}`,
    method: 'GET',
  })
}

//胎压传感器接触绑定
const delPresureBind = (carPressureSensorId) => {
  return axios({
    url: `/api/pressure/manage/${carPressureSensorId}`,
    method: 'DELETE',
  })
}

//胎压传感器下发参数
const getPresureCommand = (carPressureSensorId) => {
  return axios({
    url: `/api/pressure/manage/command/${carPressureSensorId}`,
    method: 'GET'
  })
}

//获取温度传感器图表数据
const getTemperChartData = (data) => {
  return axios({
    url: `/api/report/temperature/chart`,
    method: 'POST',
    data
  })
}

//获取温度传感器报表全部数据
const getAllTemperature = (data) => {
  return axios({
    url: `/api/report/temperature`,
    method: 'POST',
    data
  })
}

//获取温度传感器高温报表
const getHighTemperatureReport = (data) => {
  return axios({
    url: `/api/report/temperature/high`,
    method: 'POST',
    data
  })
}

//获取温度传感器低温报表
const getLowTemperatureReport = (data) => {
  return axios({
    url: `/api/report/temperature/low`,
    method: 'POST',
    data
  })
}

//获取湿度传感器图表数据
const getHumidityChartData = (data) => {
  return axios({
    url: `/api/report/humidity/chart`,
    method: 'POST',
    data
  })
}

//获取湿度传感器报表全部数据
const getAllHumidity = (data) => {
  return axios({
    url: `/api/report/humidity`,
    method: 'POST',
    data
  })
}

//获取湿度传感器高湿度报表
const getHighHumidityReport = (data) => {
  return axios({
    url: `/api/report/humidity/high`,
    method: 'POST',
    data
  })
}

//获取湿度传感器低湿度报表
const getLowHumidityReport = (data) => {
  return axios({
    url: `/api/report/humidity/low`,
    method: 'POST',
    data
  })
}

//io设置列表
const getIOList = (data) => {
  return axios({
    url: `/api/io/check/setting/list`,
    method: 'POST',
    data
  })
}

//查询io参数设置
const getIODetail = (ioMonitorId) => {
  return axios({
    url: `/api/io/monitor/${ioMonitorId}`,
    method: 'GET',
  })
}

//io参考对象下拉
const getIORefer = () => {
  return axios({
    url: `/api/io/monitor/reference`,
    method: 'GET'
  })
}

//io参数设置提交
const submitIOSetting = (data) => {
  return axios({
    url: `/api/io/monitor`,
    method: 'POST',
    data
  })
}

//恢复默认
const resetIO = (data) => {
  return axios({
    url: `/api/io/monitor/default`,
    method: 'POST',
    data
  })
}

export default {
    getTemperSensorMessage,
    getTemperSensorDetail,
    delTemperSensor,
    addTemperSensor,
    modifyTemperSensor,
    getTemperSetting,
    getTemperRefer,
    addHumSensor,
    modifyHumSensor,
    getHumSensorMessage,
    getHumSensorDetail,
    delHumSensor,
    setTemp,
    delTempBind,
    getTempCommand,
    getTempSetDetail,
    getHumRefer,
    getHumCommand,
    delHumBind,
    getHumSetting,
    getHumSetDetail,
    setHum,
    getLoadSensorMessage,
    getLoadSensorDetail,
    delLoadSensor,
    addLoadSensor,
    modifyLoadSensor,
    getPressureSensorList,
    getPressureSensorSimpleList,
    addPresureSensor,
    modifyPresureSensor,
    delPresureSensor,
    getPresureManage,
    getPresureRefer,
    setPresureManage,
    getPresureDetail,
    delPresureBind,
    getPresureCommand,
    getLoadRefer,
    getLoadSetting,
    getLoadSetDetail,
    getLoadCommand,
    delLoadBind,
    setLoad,
    getAllTemperature,
    getHighTemperatureReport,
    getLowTemperatureReport,
    getAllHumidity,
    getHighHumidityReport,
    getLowHumidityReport,
    getTemperChartData,
    getHumidityChartData,
    getIOList,
    getIODetail,
    getIORefer,
    submitIOSetting,
    resetIO
}